import React, { forwardRef } from 'react';
import type { TabBaseProps } from '../../common/types.tsx';

const StaticTab = forwardRef<HTMLDivElement, TabBaseProps>(
	({ children, isDraggable, isDragging, ...props }, ref) => (
		<div ref={ref} {...props}>
			{children}
		</div>
	),
);

export default StaticTab;
